import React from 'react';
import { Box } from '@mui/material';
import { SessionState, MaterializedView } from '@/types';
import SimulationDashboard from '@/components/Dashboard/SimulationDashboard';

interface SimulationWorkspaceProps {
  session: SessionState;
  materializedView: MaterializedView;
}

const SimulationWorkspace: React.FC<SimulationWorkspaceProps> = ({ session, materializedView }) => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#1e293b' }}>
      <SimulationDashboard session={session} materializedView={materializedView} />
    </Box>
  );
};

export default SimulationWorkspace;